import React from 'react';
import {useRouteMatch} from 'react-router-dom';
import DataTableWithFilters from 'common/components/DataTableWithFilters';
import Spinner from 'common/components/Spinner';
import ButtonSelectRow from '../ButtonSelectRow';
import saveIcon from 'common/assets/add-button.svg';
import {pathnames as P} from 'common/constants/pathnames';
import {messages as M} from '../../constants/messages';
import {excelFileNames as N} from '../../constants/excelFileNames';
import {commonColumns} from '../../../../common/constants/gridColumns';
import {convertBinaryToString} from '../../../../common/utils/form/convertBinaryToString';
import moment from "moment";

const TabShared = ({
                     getStep9Grid,
                     setStep9Page,
                     list,
                     page,
                     totalPages,
                     totalResultCount,
                     saveRow,
                     showLittlePopup,
                     saveFilters,
                     previousFilters,
                     getStep9GridSharedForExcel,
                     listForExcel,
                     ...rest
                   }) => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_ID);

  const preparedList = list && list.map(item => {
    const {price, shumaID, ...rest} = item;
    const checkboxProps = {
      action: () => {
        saveRow({shumaId, selectedShumaID: item.shumaID, price, ...rest})
          .then((response) => {
            const message = response.data.errorCode === -1
              ? M.FAILED : M.GRID_ROW_SAVED;
            showLittlePopup(message)
          })
      },
      icon: saveIcon,
    };

    return {
      price: price ? parseInt(price).toLocaleString() : '',
      shumaID,
      ...rest,
      checked: <ButtonSelectRow {...checkboxProps}/>,
    };
  });

  const headersForExcel = commonColumns.map(item => item.Header);
  const preparedListForExcel = (data) => {
    const dataForExcel = Boolean(data) ? data : [];
    return dataForExcel.map((item, index) => {
      const {
        buildingAge,
        buildingElevator,
        buildingFloorsCount,
        cityName,
        floor,
        gush,
        helka,
        houseNum,
        houseParking,
        houseRegisteredArea,
        houseRoof,
        houseRoomCount,
        houseStorage,
        houseYard,
        officialDate,
        price,
        registeredArea,
        streetName
      } = item;

      return {
        [headersForExcel[0]]: index + 1,
        [headersForExcel[1]]: Boolean(officialDate)
          ? moment(officialDate).format('DD-MM-YYYY')
          : '',
        [headersForExcel[2]]: gush,
        [headersForExcel[3]]: helka,
        [headersForExcel[4]]: cityName,
        [headersForExcel[5]]: streetName,
        [headersForExcel[6]]: houseNum,
        [headersForExcel[7]]: houseRegisteredArea,
        [headersForExcel[8]]: houseRoomCount,
        [headersForExcel[9]]: floor,
        [headersForExcel[10]]: buildingFloorsCount,
        [headersForExcel[11]]: buildingAge,
        [headersForExcel[12]]: convertBinaryToString(houseParking),
        [headersForExcel[13]]: convertBinaryToString(buildingElevator),
        [headersForExcel[14]]: convertBinaryToString(houseYard),
        [headersForExcel[15]]: convertBinaryToString(houseStorage),
        [headersForExcel[16]]: convertBinaryToString(houseRoof),
        [headersForExcel[17]]: registeredArea,
        [headersForExcel[18]]: price ? parseInt(price).toLocaleString() : '',
      }
    });
  };

  return (
    <DataTableWithFilters
      getListHandler={getStep9Grid}
      columns={commonColumns}
      data={preparedList}
      page={page}
      setPage={setStep9Page}
      totalPages={totalPages}
      totalResults={totalResultCount}
      pendingIndicator={<Spinner/>}
      additionalData={{shumaID: shumaId}}
      filtersPresistanceOptions={{
        saveFilter: saveFilters,
        previousFilters
      }}
      getListForExcel={getStep9GridSharedForExcel}
      preparedDataForExcel={preparedListForExcel(preparedList)}
      headersForExcel={headersForExcel}
      excelFileName={N.TAB_SHARED}
      allowSorting={true}
      {...rest}
    />
  );
};

export default TabShared;